module.exports = __webpack_public_path__ + "static/media/Espeon_gaussian2.cc1570fe.png";